import { FormattedText } from "@tm/static";
import React from "react";
import {
  InfoIconWrapper,
  OptionLabel,
  RadioCircle,
  RadioItem,
  SubtitleBadge,
  SubtitleText,
  TripOptionsContainer,
} from "./TripOptions.styles";
import { ITripOption } from "./types";

interface TripOptionsProps {
  options: ITripOption[];
  selectedOptionId?: string;
  onOptionChange?: (optionId: string) => void;
  onInfoIconClick?: (optionId: string) => void;
}

const TripOptions: React.FC<TripOptionsProps> = ({
  options,
  selectedOptionId,
  onOptionChange,
  onInfoIconClick,
}) => {
  if (!options?.length) return null;

  return (
    <TripOptionsContainer>
      {options.map((option) => {
        const isSelected = selectedOptionId === option.id;
        return (
          <RadioItem
            key={option.id}
            $isSelected={isSelected}
            onClick={() => onOptionChange?.(option.id)}
          >
            <RadioCircle $isSelected={isSelected} />
            <OptionLabel>
              {option.name}
              {(option.subTitle || option.icon) && (
                <SubtitleBadge>
                  {option.subTitle && (
                    <SubtitleText>
                      <FormattedText value={option.subTitle} />
                    </SubtitleText>
                  )}
                  {option.icon && (
                    <InfoIconWrapper
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onInfoIconClick?.(option.id);
                      }}
                      aria-label={`Info about ${option.name}`}
                    >
                      <img
                        src={option.icon}
                        width="14"
                        height="14"
                        alt="info"
                      />
                    </InfoIconWrapper>
                  )}
                </SubtitleBadge>
              )}
            </OptionLabel>
          </RadioItem>
        );
      })}
    </TripOptionsContainer>
  );
};

export default TripOptions;
